var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.2,
    height: 18,
    viewBox: "0 0 19.2 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_video",
    "data-name": "icona video",
    transform: "translate(-731.4 -868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video",
    transform: "translate(732 871.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2256",
    "data-name": "Tracciato 2256",
    d: "M29.727,10.5,24,14.591l5.727,4.091Z",
    transform: "translate(-11.727 -8.864)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2257",
    "data-name": "Tracciato 2257",
    d: "M3.136,7.5h9a1.636,1.636,0,0,1,1.636,1.636v8.182a1.636,1.636,0,0,1-1.636,1.636h-9A1.636,1.636,0,0,1,1.5,17.318V9.136A1.636,1.636,0,0,1,3.136,7.5Z",
    transform: "translate(-1.5 -7.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_2002",
    "data-name": "Rettangolo 2002",
    transform: "translate(732 868)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.c1015a4a063802a69887f28b9102d0c6.svg";
export { ForwardRef as ReactComponent };